import { render, staticRenderFns } from "./IntroductionInfo.vue?vue&type=template&id=7d40fb87&scoped=true&"
import script from "./IntroductionInfo.vue?vue&type=script&lang=js&"
export * from "./IntroductionInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d40fb87",
  null
  
)

export default component.exports